import { TYPE_COLLECTION } from './input-types';

export const id = 'deliveryNotification';
export const apiKey = 'DeliveryEmailSent';
export const type = TYPE_COLLECTION;

export const deliveryEmailSent = {
  id,
  apiKey,
  type,
};
